<template>
    <ul ref="fileList" class="sr-dropzone-upload-file-list">
        <li v-for="(file, index) in value" :key="index">
            <a v-if="Boolean(file.secureUrl)" :href="file.secureUrl" target="_blank" class="file-image-link">
                <img :src="file.secureUrl" :alt="file.name" class="file-image-preview" />
            </a>
            <SrIcon v-else :active="true" icon="image-icon" size="l" />
            <div class="file-details">
                <div class="file-name" :title="file.name">
                    {{ file.name }}
                </div>
                <div class="file-size">
                    {{ file.size }}
                </div>
            </div>
            <div class="file-remove">
                <SrIcon class="file-remove-icon" icon="trash" size="xs" @click="removeFile(file, index)" />
            </div>
        </li>
    </ul>
</template>

<script>
import { SrIcon } from '../SrIcon';

export default {
    name: 'SrDropzoneUploadFileList',
    components: {
        SrIcon,
    },
    props: {
        value: {
            type: Array,
            required: true,
        },
    },
    methods: {
        removeFile(file, index) {
            this.$emit('removeFile', file, index);
        },
    },
};
</script>
